document.addEventListener('DOMContentLoaded', () => {
  const url = window.location.href;

  // Show Klaviyo popup only if form was submitted successfully
  const showPopup = url.includes('?customer_posted=true') && url.includes('#contact_form');

  if (showPopup) {
    const isGerman = window.location.pathname.includes('/de');
    const isMobile = window.innerWidth < 768;

    let popupId;

    if (isGerman) {
      popupId = isMobile ? 'UBAjTd' : 'XDt4AA';
    } else {
      popupId = isMobile ? 'TMx2sJ' : 'VxzTMM';
    }

    // Wait a short time for Klaviyo to initialize (just in case)
    const openKlaviyoPopup = () => {
      if (window._klOnsite) {
        window._klOnsite.push(['openForm', popupId]);
      } else {
        console.error('Klaviyo onsite script not loaded');
      }
    };

    // Delay slightly to ensure Klaviyo is ready
    setTimeout(openKlaviyoPopup, 500);
  }

});